import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, ReactiveFormsModule, MatDialogModule, MatInputModule, MatFormFieldModule, MatCheckboxModule],
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  public form: FormGroup = this._formBuilder.group({});

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private readonly _formBuilder: FormBuilder,
    private _dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    if (typeof data.showIcon === 'undefined') {
      data.showIcon = true;
    }

    this._buildForm();
  }

  close(action: boolean): void {
    this._dialogRef.close({
      action,
      form: this.form
    });
  }

  private _buildForm(): void {
    if (!this.data.inputs?.length) return;

    for (const control of this.data.inputs) {
      const validators: ValidatorFn[] = control.validators || [];
      this.form.addControl(control.name, new FormControl(control.value, validators));
    }
  }
}

export interface ConfirmDialogData {
  title: string;
  message: string;
  type: 'danger' | 'error' | 'warning' | 'info' | 'edit' | 'success';
  inputs?: any[] | null;
  confirmText: string;
  cancelText?: string;
  showIcon?: boolean;
}